import React, { useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { IUploadedFileDto } from "../../../../common/model/file-exchange-dto";
import { BtmReturnInspectionProduct, BtmReturnInspectionStatus } from "../model/btm-return-inspection-product";
import { BtmFailedInspectionContent } from "./btm-failed-inspection-content";

interface IBtmFailedInspectionDialogProps {
    data: BtmReturnInspectionProduct;
    status: BtmReturnInspectionStatus;
    onComplete: (comment: string, files: IUploadedFileDto[]) => void;
    onClose: () => void;
}

export const BtmFailedInspectionDialog = (props: IBtmFailedInspectionDialogProps) => {
    const [commentTextValue, setCommentTextValue] = useState<string>(props.data.comment ?? "");
    const [filesList, setFilesList] = useState<IUploadedFileDto[]>(props.data.files ?? []);

    const isFormCompleted = useMemo(() =>
            filesList.length > 0 && commentTextValue !== "",
        [filesList, commentTextValue]);

    return <Dialog open={true} fullWidth classes={{ paper: "btm-failed-inspection-dialog" }}>
        <DialogTitle>
            {props.data.productName}
        </DialogTitle>
        <BtmFailedInspectionContent data={props.data} status={props.status}
                                    commentTextValue={commentTextValue}
                                    onCommentValueChange={setCommentTextValue}
                                    filesList={filesList}
                                    onFilesListChange={setFilesList} />
        <DialogActions>
            <Button variant={"contained"} color={"inherit"} onClick={props.onClose}>Cancel</Button>
            <Button variant={"contained"} color={"secondary"} disabled={!isFormCompleted}
                    onClick={() => props.onComplete(commentTextValue, filesList)}>
                Complete
            </Button>
        </DialogActions>
    </Dialog>;
};
